import React from "react"
import { Link } from "gatsby"
import { Card } from "reactstrap"
import Img from "gatsby-image"
import site from "../../utilty/getURL"

export default function StickyPost({ post }) {
  return (
    <div>
      <div className="row desktopSticky">
        <div className="col-sm-12 col-lg-8 p-0">
          <Card className="Stickycontainer mb-0">
            <div>
              <Link to={`${site.siteMetadata.siteUrl}/${post[0].node.slug}`}>
                <Img
                  className="card-image-top"
                  fluid={post[0].node.heroImage.fluid}
                  alt={post[0].node.title}
                />
              </Link>
            </div>
            <div className="bottom-left bg-sticky">
              <Link to={`${site.siteMetadata.siteUrl}/${post[0].node.slug}`}>
                <h2 className="sticky-title ">{post[0].node.title}</h2>
              </Link>{" "}
            </div>
          </Card>
        </div>
        <div className="col-sm-12 col-lg-4 p-0">
          <div className="row ">
            <div className="col-lg-12 col-sm-6 ">
              {" "}
              <div className="Stickycontainer flex-container">
                <Link to={`${site.siteMetadata.siteUrl}/${post[1].node.slug}`}>
                  <Img
                    className="card-image-top"
                    fluid={post[1].node.heroImage.fluid}
                    alt={post[1].node.title}
                  />
                </Link>
                <div className="bottom-left bg-sticky">
                  <Link
                    to={`${site.siteMetadata.siteUrl}/${post[1].node.slug}`}
                  >
                    <h2 className="sticky-title ">{post[1].node.title}</h2>
                  </Link>{" "}
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-sm-6 ">
              <div className="Stickycontainer">
                <Link to={`${site.siteMetadata.siteUrl}/${post[2].node.slug}`}>
                  <Img
                    className="card-image-top"
                    fluid={post[2].node.heroImage.fluid}
                    alt={post[2].node.title}
                  />
                </Link>
                <div className="bottom-left bg-sticky">
                  <Link
                    to={`${site.siteMetadata.siteUrl}/${post[2].node.slug}`}
                  >
                    <h2 className="sticky-title ">{post[2].node.title}</h2>
                  </Link>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mobileSticky">
        <div className="col-sm-12 m-0 p-0">
          <Card className="Stickycontainer m-0 p-0">
            <div>
              <Link to={`${site.siteMetadata.siteUrl}/${post[0].node.slug}`}>
                <Img
                  className="card-image-top"
                  fluid={post[0].node.heroImage.fluid}
                  alt={post[0].node.title}
                />
              </Link>
            </div>
            <div className="bottom-left bg-sticky">
              <Link to={`${site.siteMetadata.siteUrl}/${post[0].node.slug}`}>
                <h2 className="sticky-title ">{post[0].node.title}</h2>
              </Link>{" "}
            </div>
          </Card>
        </div>
        <div className="col-6 p-0 pl-1 m-0">
          <div className="Stickycontainer ">
            <Link to={`${site.siteMetadata.siteUrl}/${post[1].node.slug}`}>
              <Img
                className="card-image-top"
                fluid={post[1].node.heroImage.fluid}
                alt={post[1].node.title}
              />
            </Link>
            <div className="bottom-left bg-sticky">
              <Link to={`${site.siteMetadata.siteUrl}/${post[1].node.slug}`}>
                <h2 className="sticky-title ">{post[1].node.title}</h2>
              </Link>{" "}
            </div>
          </div>
        </div>
        <div className="col-6 p-0 pl-1  m-0">
          {" "}
          <div className="Stickycontainer">
            <Link to={`${site.siteMetadata.siteUrl}/${post[2].node.slug}`}>
              <Img
                className="card-image-top"
                fluid={post[2].node.heroImage.fluid}
                alt={post[2].node.title}
              />
            </Link>
            <div className="bottom-left bg-sticky">
              <Link to={`${site.siteMetadata.siteUrl}/${post[2].node.slug}`}>
                <h2 className="sticky-title ">{post[2].node.title}</h2>
              </Link>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

//  category.description
